import step1Splash from "@/assets/images/demo-kit/step-1-splash.svg";
import step2Splash from "@/assets/images/demo-kit/step-2-splash.svg";
import step2SplashMobile from "@/assets/images/demo-kit/step-2-splash-mobile.svg";
import step3Splash from "@/assets/images/demo-kit/step-3-splash.svg";
import step3SplashMobile from "@/assets/images/demo-kit/step-3-splash-mobile.svg";
import step4Splash from "@/assets/images/demo-kit/step-4-splash.svg";

export const SUMMIT_TOUR_IMAGES = [
  step1Splash,
  step2Splash,
  step3Splash,
  step4Splash,
] as const;

/** Steps 2 and 3 use a narrower composition on small screens. */
export const SUMMIT_TOUR_MOBILE_IMAGES = [
  step2SplashMobile,
  step3SplashMobile,
] as const;

// Kept alive so the browser does not cancel the downloads when the local
// Image objects would otherwise be garbage-collected.
const preloadedImages: HTMLImageElement[] = [];

/**
 * Warms the browser cache for the Summit tour images. Call this as soon as
 * the tour is reachable (e.g. when the trip-confirmed step mounts), well
 * before the trip page's own data requests start competing for connections.
 */
export const preloadSummitTourImages = (): void => {
  if (preloadedImages.length > 0 || typeof document === "undefined") {
    return;
  }

  [...SUMMIT_TOUR_IMAGES, ...SUMMIT_TOUR_MOBILE_IMAGES].forEach((src) => {
    const link = document.createElement("link");
    link.rel = "preload";
    link.as = "image";
    link.href = src;
    document.head.appendChild(link);

    const image = new Image();
    image.src = src;
    preloadedImages.push(image);
  });
};
